<template>
<div :class="['icon', iconType, iconOptions]">
  <img v-if="icon === 'check'" src="~@/assets/images/ui/icon-check.svg" alt="green check icon" />
  <img v-if="icon === 'x-red'" src="~@/assets/images/ui/x-red.svg" alt="red x icon" />
  <img v-if="icon === 'x-gray'" src="~@/assets/images/ui/x-gray.svg" alt="gray x icon" />
  <img v-if="icon === 'info'" src="~@/assets/images/ui/icon-info.svg" alt="blue info icon" />
</div>
</template>

<script>
export default {
  name: 'UnumIcon',
  computed: {
    iconType () {
      return this.icon ? `icon--${this.icon}` : false
    },
    iconOptions () {
      return {
        'icon--displayBlock': this.displayBlock
      }
    }
  },
  props: {
    icon: {
      type: String
    },
    displayBlock: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss">
.icon {
  display: inline-block;

  img {
    height: 1.5rem;
    width: 1.5rem;
  }

  &--displayBlock {
    display: block;
    margin: 0 auto;
  }

  &--check {
    img {
      width: 1.3rem;
      height: 1.3rem;
    }
  }

  &--x-red {
    img {
      width: 1rem;
      height: 1rem;
    }
  }

  &--x-gray {
    img {
      width: 1rem;
      height: 1rem;
    }
  }

  &--info {
    img {
      width: 1rem;
      height: 1rem;
      @include bp($small) {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Icon.vue